import autobind from 'core-decorators/lib/autobind';


const INACTIVE_CHANNEL_TIMEOUT = 2 * 60 * 1000;


class Channels {

  constructor() {
    this.privateMedia = null;
    this.openingPromises = null;
    this.isOpened = false;
    this.autoCloseTimeout = null;

    this.listeners = [];
  }

  setup(options) {
    this.privateMedia = options.wixPrivateMedia;
  }

  closeByTimeout() {
    clearTimeout(this.autoCloseTimeout);
    this.autoCloseTimeout = setTimeout(this.close, INACTIVE_CHANNEL_TIMEOUT);
  }

  startListen(listenerName) {
    clearTimeout(this.autoCloseTimeout);

    if (!this.isOpened) {
      this.open();
    }

    if (!_.includes(this.listeners, listenerName)) {
      this.listeners.push(listenerName);
    }
  }

  stopListen(listenerName) {
    this.listeners = _.without(this.listeners, listenerName);

    if (_.isEmpty(this.listeners)) {
      this.closeByTimeout();
    }
  }

  open() {
    if (!this.privateMedia) {
      throw new Error('`privateMedia` should be setted. see setup() method.');
    }

    if (this.isOpened) {
      return;
    }

    if (!this.openingPromises) {
      console.log('channel & web-sockets opened'); // eslint-disable-line no-console

      this.openingPromises = Promise.race([
        this.privateMedia.channel.open(),
        this.privateMedia.blackArrow.open(),
      ]);

      this.openingPromises.then(() => {
        this.isOpened = true;
      });
    }
  }

  @autobind
  close() {
    if (!this.isOpened) {
      return;
    }

    console.log('channel & web-sockets closed'); // eslint-disable-line no-console
    this.privateMedia.channel.close();
    this.privateMedia.blackArrow.close();
    this.isOpened = false;
    this.openingPromises = null;
  }
}

export default new Channels();



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/channels/channels.js